import { useQuery } from "@tanstack/react-query";
import { getProspectPoolAvailability } from "@/app/actions/prospect-pool/action";
import { QueryKey } from "@/app/vars/QueryKeys";

type Options = {
  avatarId?: number;
  enabled?: boolean;
};

export function useFetchProspectPool(options: Options) {
  const { avatarId, enabled = true } = options;

  return useQuery({
    queryKey: [QueryKey.PROSPECT_POOL, avatarId],
    queryFn: () => getProspectPoolAvailability(avatarId!),
    enabled: enabled && !!avatarId,
    staleTime: Infinity,
  });
}
